/**
 * UI state of the Assets panel shared with the `assets.rename` command (W2-10 projects-data): the file whose name
 * is being edited in place.
 */

import { useSyncExternalStore } from 'react';
import type { AssetId } from '../../core/model/types';
import type { Unsubscribe } from '../../core/util/types';

let renaming: AssetId | null = null;
const listeners = new Set<() => void>();

const getRenaming = (): AssetId | null => renaming;

const subscribe = (cb: () => void): Unsubscribe => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};

export const assetsUi = {
  renaming: getRenaming,
  setRenaming: (id: AssetId | null): void => {
    if (renaming === id) return;
    renaming = id;
    for (const cb of [...listeners]) cb();
  },
  subscribe,
};

/** The file being renamed in place (re-renders on change). */
export function useRenaming(): AssetId | null {
  return useSyncExternalStore(subscribe, getRenaming, getRenaming);
}
